import { render } from "./IconTitle.vue?vue&type=template&id=ff2f0aa2&scoped=true"
import script from "./IconTitle.vue?vue&type=script&lang=js"
export * from "./IconTitle.vue?vue&type=script&lang=js"

import "./IconTitle.vue?vue&type=style&index=0&id=ff2f0aa2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff2f0aa2"]])

export default __exports__